import {Component, OnInit, Type, EventEmitter, Output, Input} from '@angular/core';
import {TreeNode} from 'angular-tree-component';
import {ModalService} from 'app/core/services/modal.service';
import {ModalSize, SmartModalService} from 'app/core/services/smart-modal.service';
import {RxComponent} from 'app/core/components/common/rx.component';
import {TopicsService} from './topics.service';
import {TopicSubtopicAddComponent} from './add/topic-subtopic-add.component';
import { SvgUploaderModalComponent } from './svg-uploader-modal/svg-uploader-modal.component';

declare var $: any

@Component({
    selector: 'itpx-topics',
    templateUrl: './topics.component.html',
    styleUrls: ['./topics.component.css']
})
export class TopicsComponent extends RxComponent implements OnInit {

    @Output() onPageChangedEvent = new EventEmitter<boolean>();
    private topics: any
    subTopics: any;
    topicSearch: string

    private page: number = 1;
    private limit: number = 10;
    private itemsCount: number;
    private filter: string = ''

    constructor(
        private modal: ModalService,
        private modalService: SmartModalService,
        private service: TopicsService
    ) {super()}

    ngOnInit() {
      this.fetch();
    }
    fetch(): any {
        this.service.list(this.page, this.limit, this.filter)
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.topics = body.data
                    this.itemsCount = body.flags.size
                }
            )
    }
    private onPageClick(event: any) {
        this.page = event.page;
        this.onPageChangedEvent.emit(event);
        this.fetch()
    }

    private showMore(index: number) {
        let arrowId = 'arrow-' + index;
        let divId = 'content-' + index;
        let lineId = 'line-' + index
        let arrow = $(document.querySelector('#' + arrowId));
        let div = $(document.querySelector('#' + divId));
        let line = $(document.querySelector('#' + lineId));
        arrow.toggleClass('rotated');
        div.toggleClass('hidden');
        line.toggleClass('hidden');
    }

    onEdit(e, topic, subtopic) {
        let title: string;
        let data: any
        if (e === 'topic') {
            title = 'Edit Topic'
            data = { node: topic ? topic : null } 
        } else if (e === 'subtopic') { 
            title = 'Edit Sub-Topic'
            data = {
                parent: topic ? topic : null,
                node: subtopic ? subtopic : null
            }
        } else throw new Error('Unknown action')

        this.modalService.open(<Type<Component>>TopicSubtopicAddComponent, data, title)
            .neverError()
            .map(data => {
                    let nestedArr = data.result.nested;
                    data.result.type = e;
                    data.result.nested = (nestedArr || nestedArr.length).map(el => ({id: el.id }))
                    return data.result
            })
            .switchMap(data => this.service.edit(data))
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    this.fetch();
                }
            )
    }

    onAdd(e, topic) {
        const title = e === 'topic' ? 'Add Topic' : 'Add Sub-Topic'
        this.modalService.open(<Type<Component>>TopicSubtopicAddComponent, {parent: topic}, title)
        .neverError()
        .map(data => {
            data.result.type = e;
            return data.result
        })
        .switchMap(data => this.service.add(data))
        .bindToLifecycle(this)
        .subscribe(
            body => {
                this.fetch();
            }
        )

    }
    removeTopic(node: TreeNode, event: any) {
        this.modal.confirm('Delete', 'Are you sure you want to delete this topic?')
            .neverError()
            .flatMap(data => this.service.delete({id: node.data.id}))
            .bindToLifecycle(this)
            .subscribe(
                event => {
                    this.fetch();
                }
            );
    }
    removeSubtopic(node: TreeNode, event: any) {
        this.modal.confirm('Delete', 'Are you sure you want to delete this subtopic?')
            .neverError()
            .map(data => {
                let result = node.parent.data;
                let nodeArray = node.parent.data.nested
                let index = nodeArray.findIndex(el => el.id === node.id);
                delete result.nested[index];
                return result
            })
            .flatMap(data => this.service.edit(data))
            .bindToLifecycle(this)
            .subscribe(
                data => {
                    this.fetch();
                }
            );
    }

    onMoveNode(node: TreeNode, event: any) {
        const parentFrom = event.node.parent.data;
        let nodeArray = node.parent.data.nested
        let index = nodeArray.findIndex(el => el.id === node.id);
        delete parentFrom.nested[index];

        const result = event.to.parent;
        if(result.virtual) delete result.id;

        this.service.edit(parentFrom)
            .flatMap(data =>  this.service.edit(result))
            .bindToLifecycle(this)
            .subscribe(
                event => {
                    this.fetch();
                })
    }

    onCopyNode(node: any, event: any) {
        const result = event.to.parent;
        if(result.virtual) delete result.id;
        result.nested = result.nested && result.nested.length ? result.nested.map(el => {return {id: el.id }}) : [];
        this.service.edit(result)
            .bindToLifecycle(this)
            .subscribe(
                event => {
                    this.fetch();
                })
    }
    
    trackByFn(index, item) {
        if (!item) return null
        return item
    }

    private onFilter(event: any) {
        this.filter = event.target.value;
        this.fetch();
    }

    onUploadIcon(e) {
        this.modalService.open(<Type<Component>>SvgUploaderModalComponent,
            e, 'Upload Icon', ModalSize.Md, 'center', true)
            .neverError()
            .subscribe(_ => this.fetch());
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/topics/topics.component.ts